import { config } from '../config/env';

/**
 * Get the image URL for an image ID
 * Uses the server's /api/image/:imageId endpoint
 * @param imageId - The Cloudflare Images image ID
 * @param type - Image type: 'thumbnail' for smaller images, undefined/null for full-size (public)
 */
export function getImageUrl(imageId: string | undefined | null, type?: 'thumbnail' | 'public'): string | null {
  if (!imageId) return null;
  
  // Construct URL to the server's image endpoint
  // config.apiUrl is like "http://localhost:8787/api", so we append "/image/:imageId"
  const query = type === 'thumbnail' ? '?type=thumbnail' : '';
  return `${config.apiUrl}/image/${imageId}${query}`;
}

/**
 * Get image ID from an item (handles both imageId and image_id fields)
 */
export function getImageId(item: { imageId?: string; image_id?: string; url?: string }): string | null {
  return item.imageId || item.image_id || null;
}

